import Swal from "sweetalert2"
import { API } from "../../services/axios"
import { toast } from "react-toastify"

const confirmDeletion = (deletionUrl, t, onSuccess) => {

    Swal.fire({
        title: t("Etes-vous sur(e)?"),
        text: t("Alert Suppression irreversible"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t("Supprimer"),
        cancelButtonText: t("Annuler"),
        showLoaderOnConfirm: true,
        timerProgressBar: true,

      }).then((result) => {
        if (result.isConfirmed) {
            const id = toast.loading(t("Suppression en cours"))
            API.delete(deletionUrl).then((resp) => {
                Swal.fire(
                  t("Supprimé"),
                  t("deletionSuccessMessage"),
                  'success'
                );
                onSuccess() 
                toast.update(id, {render: t("Success Message"), type: "success", isLoading: false, autoClose:true});
            }).catch(error => {
                toast.update(id, {render: t("requestGlobalErrorMessage"), type: "error", isLoading: false, autoClose:true });
            })
        }
      })
}

export { confirmDeletion }